import React, { useEffect } from "react";
import styles from "./OnboardingWelcome.module.scss";
import "../../../styles/sharedStyles.scss";
import SubDealerList from "./subDealerList/SubDealerList";
import Grid from "@mui/material/Grid";
import { withTranslation } from "react-i18next";
import FordLogo from "../../../common/FordLogo";
import HasPermissionTo from "../../../common/HasPermissionTo";

const OnboardingWelcome = (props) => {
  useEffect(() => {
    props.showActionFooter(true);
  }, []);

  const mainDealer = () => {
    let dealerName = "";

    if (props.dealerGroup.length === 1) {
      dealerName = props.dealerGroup[0].name;
    } else if (props.dealerGroup.length > 1) {
      props.dealerGroup.forEach(function (dealer) {
        if (dealer.dealerType === "MDLR" || dealer.dealerType === "HUB") {
          dealerName = dealer.name;
        }
      });
    }

    return dealerName;
  };

  if (props.dealerGroup.length < 1) {
    return (
      <div data-testid="onboard-welcome">
        <h1 className={styles.pageTitle1}>
          {props.t("OnboardingWelcome.dealerError")}
        </h1>
      </div>
    );
  } else {
    return (
      <div className="pageWrapper">
        <div className="pagePadding">
          <Grid container spacing={24}>
            <Grid item md={12} className={styles.center}>
              <FordLogo className={styles.brandLogo} />
            </Grid>
            <Grid item md={12} className={styles.center}>
              <div className={styles.welcomeTitle}>
                {props.t("GeneralEMP.onboarding")}
              </div>
            </Grid>
            <Grid item md={12}>
              <div className={styles.welcome}>
                {props.t("OnboardingWelcome.welcome")}
                {mainDealer()}
              </div>
            </Grid>
          </Grid>
          <HasPermissionTo
            perform={["onboardingSteps:view"]}
            permissions={props.userDetails.permissions.rolePermissions}
            render={() => {
              return (
                <Grid container spacing={24}>
                  <Grid item md={12}>
                    <div className={styles.toCompleteTheOnboarding}>
                      {props.t("OnboardingWelcome.sublineTwo")}
                    </div>
                  </Grid>

                  <Grid item md={12}>
                    <div>
                      <span className="lineNumber">1 </span>
                      <span className="lineText">
                        {" "}
                        {props.t("OnboardingWelcome.stepOne")}
                      </span>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div>
                      <span className="lineNumber">2 </span>
                      <span className="lineText">
                        {" "}
                        {props.t("OnboardingWelcome.stepTwo")}
                        <span className={styles.normalFontWeight}>
                          {" "}
                          {props.t("OnboardingWelcome.stepTwoSub")}
                        </span>
                      </span>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div>
                      <span className="lineNumber">3 </span>
                      <span className="lineText">
                        {" "}
                        {props.t("OnboardingWelcome.stepThree")}
                      </span>
                    </div>
                  </Grid>
                </Grid>
              );
            }}
            noRender={() => {
              return (
                <Grid container spacing={24}>
                  <Grid item md={12}>
                    <div className={styles.toCompleteTheOnboarding}>
                      {props.t("OnboardingWelcome.acceptTerms")}
                    </div>
                  </Grid>
                </Grid>
              );
            }}
          />

          <Grid container spacing={24}>
            <Grid item md={12}>
              <div>
                <span className={styles.toCompleteTheOnboarding}>
                  {" "}
                  {props.t("OnboardingWelcome.setupRequired")}
                </span>
              </div>
              <div>
                <div className={styles.subDealer}>
                  {props.dealerGroup.map((dealer) => (
                    <SubDealerList
                      dealer={dealer}
                      key={dealer.completeDealerId}
                    />
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
};

export default withTranslation("emp")(OnboardingWelcome);
